module.exports = __webpack_public_path__ + "assets/public/imgs/restricted-sign.svg";